import {
  type PayloadAction,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import type {RootState} from 'store/types';
import type {
  MergeSuggestionQueueItem,
  MergeSuggestionQueueState,
} from './types';

const initialState: MergeSuggestionQueueState = [];

const mergeSuggestionQueueSlice = createSlice({
  name: 'mergeSuggestionQueue',
  initialState,
  reducers: {
    setMergeSuggestionQueue: (
      _state,
      action: PayloadAction<MergeSuggestionQueueItem[]>,
    ) => {
      return action.payload;
    },
    clearMergeSuggestionQueue: () => {
      return initialState;
    },
    removeMergeSuggestionFromQueue: (
      state,
      action: PayloadAction<Pick<MergeSuggestionQueueItem, 'link'>>,
    ) => {
      return state.filter(item => {
        item.link !== action.payload.link;
      });
    },
  },
});

export const {
  setMergeSuggestionQueue,
  clearMergeSuggestionQueue,
  removeMergeSuggestionFromQueue,
} = mergeSuggestionQueueSlice.actions;

export const selectMergeSuggestionQueue = (state: RootState) =>
  state.mergeSuggestionQueue;

export const selectNextMergeSuggestionInQueue = createSelector(
  [selectMergeSuggestionQueue],
  state => state?.[0],
);

export default mergeSuggestionQueueSlice;
